<template>
  <div :class="$style['v-collapse']">
    <button @click.stop="handleExpand" :class="$style['button']">
      <span v-if="!expanded" v-color="colorFont">{{
        expandText || 'View more'
      }}</span>
      <span v-if="expanded" v-color="colorFont">{{
        collapseText || expandText || 'View more'
      }}</span>
      <img
        src="@assets/images/icons/down.svg"
        alt="arrow"
        :class="{ [$style['arrow']]: true, [$style['expanded']]: expanded }"
      />
    </button>
    <div :class="$style['items']">
      <transition
        name="staggered-fade"
        tag="div"
        :css="false"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      >
        <div v-show="expanded">
          <slot></slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import velocity from 'velocity-animate'
export default {
  props: {
    expandText: {
      type: String,
      default: 'View more',
    },
    collapseText: {
      type: String,
      default: null,
    },
    colorFont: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    expanded: false,
  }),
  methods: {
    handleExpand() {
      this.expanded = !this.expanded
    },
    beforeEnter(el) {
      const array = [...el.children]
      array.forEach((item) => {
        item.style.opacity = 0
        item.style.height = 0
        item.style.overflow = 'hidden'
      })
    },
    enter(el) {
      const array = [...el.children]
      array.forEach((item, index) => {
        const delay = index * 150
        setTimeout(() => {
          velocity(item, { opacity: 1, height: '100%' })
        }, delay)
      })
    },
    leave(el) {
      const array = [...el.children]
      array.forEach((item, index) => {
        const delay = (array.length - index) * 150
        setTimeout(() => {
          velocity(item, { opacity: 0, height: 0 })
        }, delay)
      })
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.v-collapse {
  width: 100%;

  span {
    font-size: 14px;
    font-weight: 500;
  }

  img {
    width: 16px;
  }

  li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .button {
    align-items: center;
    background-color: transparent;
    border: 0;
    display: flex;
    height: auto;
    justify-content: space-between;
    margin: 4px 0;
    outline: 0;
    padding: 0;

    span {
      font-size: 14px;
      font-weight: normal;
      line-height: 1;
      margin-right: 4px;
    }
  }

  .arrow {
    transition: transform 0.5s;

    &.expanded {
      transform: rotate(-180deg);
    }
  }
}
</style>
